import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../app/hooks';
import { SelectNetwork } from '../../../components';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import {
  SendingTokenType,
  USDT,
  formatUSD,
  formatUSDNoDecimals
} from '../../../helpers/helperFunctions';
import { CaptionText, H2, P1, P3 } from '../../../styles/FontStyles';
import { Button, Flexed, SelectedUSDT } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { TokensType, WalletsType } from '../../../types/types';
import { PurchaseSteps, Tokens } from '../../Marketplace/Maeketplace.types';

import voucherImage from '../../../assets/images/backoffice/willyImages/voucherCoins.png';
import { SelectToken } from '../../../components/common/SelectNetwork/SelectToken';

interface PayTetherProps {
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedPackage: any;
  selectedLicence: any;
  selectedNetwork: WalletsType;
  setSelectedNetwork: Dispatch<SetStateAction<WalletsType>>;
  selectedToken: TokensType;
  setSelectedToken: Dispatch<SetStateAction<TokensType>>;
  setUsdt: Dispatch<SetStateAction<string>>;
  setUsdc: Dispatch<SetStateAction<string>>;
  lp: string;
  club: string;
  usdt: string;
  usdc: string;
  cash: string;
  handlePay: (step: PurchaseSteps) => void;
}

export const PayTether = ({
  selectedPackage,
  selectedLicence,
  selectedNetwork,
  setSelectedNetwork,
  selectedToken,
  setSelectedToken,
  setUsdc,
  setUsdt,
  usdt,
  usdc,
  handlePay
}: PayTetherProps) => {
  const { t } = useTranslation('marketplace');

  const [checkbox, setCheckbox] = useState(false);

  const handlePayTether = (event: any) => {
    event.currentTarget.disabled = true;
    handlePay(PurchaseSteps.SUCCESS);
  };

  const {
    price,
    weeklyCap,
    packageId,
    limitedQuantity,
    calculator,
    tradingBinaryPercentage,
    willyMemeCoins,
    memeBonusActivationPrice,
    isMemeBonusActivated
    // eslint-disable-next-line no-unsafe-optional-chaining
  } = selectedPackage;

  return (
    <div>
      <P1 bold mb='20'>
        SELECTED VOUCHER:
      </P1>

      <Hub
        key={packageId}
        condensed
        image={voucherImage}
        title={`${formatUSDNoDecimals(price)} Will per day`}
        price={memeBonusActivationPrice}
        isMemeBonusActivated={!isMemeBonusActivated}
        packagePrice={price}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        includesSubscription={selectedLicence?.access}
        willyMemeCoins={willyMemeCoins}
        info={
          <>
            {calculator && (
              <Flexed alignEnd end>
                <H2 bold mr='16' alignEnd>
                  {calculator}
                </H2>
                <CaptionText bold right mb='4'>
                  {t('reward')}
                  <br />
                  {t('multiplicator')}
                </CaptionText>
              </Flexed>
            )}
          </>
        }
      />

      <P3 mb='8'>Select the USDT network and create a Voucher order.</P3>

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('payment_method.payment_ammount')}
      </P3>

      <SelectedUSDT>{formatUSD(memeBonusActivationPrice)}</SelectedUSDT>

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('selected_network')}
      </P3>

      <SelectNetwork
        onChange={(n) => setSelectedNetwork(n)}
        value={selectedNetwork}
      />

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('select_token')}
      </P3>

      <SelectToken
        onChange={(token) => {
          setSelectedToken(token);

          if (token.index === Tokens.TETHER) {
            setUsdt(memeBonusActivationPrice);
            setUsdc('');
          } else {
            setUsdt('');
            setUsdc(memeBonusActivationPrice);
          }
        }}
        value={selectedToken}
      />

      {selectedNetwork && (
        <P3 bold mb='25' color={color.colors.error500}>
          <SendingTokenType network={selectedNetwork?.networkType} />
        </P3>
      )}

      {selectedNetwork && (
        <CheckText
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
          text={t('payment_method.i_understand')}
        />
      )}

      <Button
        mt={20}
        disabled={!selectedNetwork || !checkbox}
        onClick={handlePayTether}>
        {t('payment_method.create_order')}
      </Button>
    </div>
  );
};
